export const referrals = [
  {
    avatar: '/assets/profile/avatar/1.png',
    username: '@Gamer.PR',
    ref: 35,
  },
  {
    avatar: '/assets/profile/avatar/2.png',
    username: '@Rai.09',
    ref: 34,
  },
  {
    avatar: '/assets/profile/avatar/3.png',
    username: '@Witty.Spectre',
    ref: 32,
  },
]
